export default __webpack_public_path__ + "dim-b9adbb.json";